/**
 * Aditi Jewelry — Shopify 2.0 Theme JS
 * Luxury editorial jewelry brand
 */

(function () {
  'use strict';

  /* ==========================================================================
     1. Scroll Reveal — Intersection Observer
     ========================================================================== */

  function initScrollReveal() {
    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) {
      // Make everything visible immediately
      document.querySelectorAll('.sr, .sr-left, .sr-right, .sr-scale, .sr-stagger').forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observerOptions = {
      root: null,
      rootMargin: '0px 0px -60px 0px',
      threshold: 0.15
    };

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    var targets = document.querySelectorAll('.sr, .sr-left, .sr-right, .sr-scale, .sr-stagger');
    targets.forEach(function (target) {
      observer.observe(target);
    });
  }

  /* ==========================================================================
     2. Navbar Scroll Behavior (transparent -> dark)
     ========================================================================== */

  function initNavbar() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var isHome = document.body.classList.contains('template-index');
    var scrollThreshold = 80;

    function updateNav() {
      var scrollY = window.scrollY || window.pageYOffset;

      if (isHome) {
        if (scrollY > scrollThreshold) {
          header.classList.add('site-header--scrolled');
          header.classList.remove('site-header--transparent');
        } else {
          header.classList.remove('site-header--scrolled');
          header.classList.add('site-header--transparent');
        }
      }
    }

    // Set initial state
    if (isHome) {
      header.classList.add('site-header--transparent');
    } else {
      header.classList.add('site-header--opaque');
    }

    // Throttled scroll handler
    var ticking = false;
    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          updateNav();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });

    updateNav();
  }

  /* ==========================================================================
     3. Hero Video Parallax
     ========================================================================== */

  function initHeroParallax() {
    var heroMedia = document.querySelector('.hero-media');
    if (!heroMedia) return;

    var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReduced) return;

    var mediaElement = heroMedia.querySelector('video, img');
    if (!mediaElement) return;

    var ticking = false;

    function updateParallax() {
      var scrollY = window.scrollY || window.pageYOffset;
      var windowHeight = window.innerHeight;

      // Only apply parallax in the hero viewport
      if (scrollY < windowHeight * 1.2) {
        var translateY = scrollY * 0.3;
        var scale = 1 + scrollY * 0.0002;
        mediaElement.style.transform = 'translateY(' + translateY + 'px) scale(' + scale + ')';
      }
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        window.requestAnimationFrame(function () {
          updateParallax();
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* ==========================================================================
     4. Category Filter with Grid Animation (shop-all page)
     ========================================================================== */

  function initCategoryFilter() {
    var filterContainer = document.querySelector('.category-filters');
    if (!filterContainer) return;

    var buttons = filterContainer.querySelectorAll('.category-filter-btn');
    var grid = document.querySelector('.product-grid');
    if (!grid) return;

    var items = grid.querySelectorAll('.product-grid-item');

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var category = this.getAttribute('data-category');

        // Update active state
        buttons.forEach(function (b) { b.classList.remove('is-active'); });
        this.classList.add('is-active');

        // Animate grid items
        animateGridFilter(items, category);
      });
    });
  }

  function animateGridFilter(items, category) {
    var delay = 0;
    var staggerMs = 50;

    items.forEach(function (item) {
      var itemCategory = item.getAttribute('data-category');
      var shouldShow = category === 'all' || itemCategory === category;

      if (shouldShow) {
        // Show item with staggered delay
        setTimeout(function () {
          item.classList.remove('is-hidden');
          item.classList.add('is-visible');
          item.style.display = '';
        }, delay);
        delay += staggerMs;
      } else {
        // Hide item
        item.classList.add('is-hidden');
        item.classList.remove('is-visible');
        // After transition, set display none for layout
        setTimeout(function () {
          if (item.classList.contains('is-hidden')) {
            item.style.display = 'none';
          }
        }, 500);
      }
    });
  }

  /* ==========================================================================
     5. Mobile Menu Toggle with Staggered Animation
     ========================================================================== */

  function initMobileMenu() {
    var toggle = document.querySelector('.mobile-menu-toggle');
    var menu = document.querySelector('.mobile-menu');
    if (!toggle || !menu) return;

    var isOpen = false;

    toggle.addEventListener('click', function () {
      isOpen = !isOpen;

      if (isOpen) {
        menu.classList.add('is-open');
        toggle.classList.add('is-open');
        document.body.style.overflow = 'hidden';
      } else {
        menu.classList.remove('is-open');
        toggle.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });

    // Close on link click
    var menuLinks = menu.querySelectorAll('a');
    menuLinks.forEach(function (link) {
      link.addEventListener('click', function () {
        isOpen = false;
        menu.classList.remove('is-open');
        toggle.classList.remove('is-open');
        document.body.style.overflow = '';
      });
    });

    // Close on escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && isOpen) {
        isOpen = false;
        menu.classList.remove('is-open');
        toggle.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  /* ==========================================================================
     6. Smooth scroll for anchor links
     ========================================================================== */

  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var targetId = this.getAttribute('href');
        if (targetId === '#') return;

        var target = document.querySelector(targetId);
        if (target) {
          e.preventDefault();
          var headerHeight = document.querySelector('.site-header')
            ? document.querySelector('.site-header').offsetHeight
            : 0;
          var targetPosition = target.getBoundingClientRect().top + window.scrollY - headerHeight;

          window.scrollTo({
            top: targetPosition,
            behavior: 'smooth'
          });
        }
      });
    });
  }

  /* ==========================================================================
     7. Lazy loading fallback for older browsers
     ========================================================================== */

  function initLazyLoad() {
    if ('loading' in HTMLImageElement.prototype) return; // native support

    var lazyImages = document.querySelectorAll('img[loading="lazy"]');
    if (!lazyImages.length) return;

    var imageObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          if (img.dataset.src) {
            img.src = img.dataset.src;
          }
          imageObserver.unobserve(img);
        }
      });
    });

    lazyImages.forEach(function (img) {
      imageObserver.observe(img);
    });
  }

  /* ==========================================================================
     8. Milestones navigation cache guard
     ========================================================================== */

  function initMilestonesNavCacheGuard() {
    var milestonesPath = '/pages/milestones';
    var freshMilestonesUrl = milestonesPath + '?view=milestones';
    var isMilestonesPage = window.location.pathname === milestonesPath;
    var hasFreshMilestonesLayout = !!document.querySelector('.milestones-feature');
    var currentParams = new URLSearchParams(window.location.search);

    if (isMilestonesPage && !hasFreshMilestonesLayout && currentParams.get('view') !== 'milestones') {
      window.location.replace(freshMilestonesUrl);
      return;
    }

    function linkExists(container) {
      return !!container.querySelector('a[href*="/pages/milestones"], a[href*="/pages/achievements"]');
    }

    function findStoryLink(container) {
      var links = Array.prototype.slice.call(container.querySelectorAll('a'));
      return links.find(function (link) {
        return link.href.indexOf('/pages/our-story') !== -1 || link.textContent.trim().toLowerCase() === 'our story';
      });
    }

    var desktopNav = document.querySelector('.adn-nav-links');
    if (desktopNav && !linkExists(desktopNav)) {
      var storyLink = findStoryLink(desktopNav);
      var desktopWrapper = document.createElement('div');
      desktopWrapper.style.position = 'relative';
      desktopWrapper.innerHTML = '<a href="' + freshMilestonesUrl + '" class="adn-nav-link" style="position:relative; font-size:13px; font-weight:400; letter-spacing:0.2em; text-transform:uppercase; color:rgba(255,255,255,0.4); text-decoration:none; transition:color 0.5s ease;">Milestones</a>';

      if (storyLink && storyLink.parentElement) {
        storyLink.parentElement.insertAdjacentElement('afterend', desktopWrapper);
      } else {
        desktopNav.appendChild(desktopWrapper);
      }
    }

    var mobileNav = document.querySelector('.adn-mobile-nav');
    if (mobileNav && !linkExists(mobileNav)) {
      var mobileStoryLink = findStoryLink(mobileNav);
      var mobileLink = document.createElement('a');
      mobileLink.href = freshMilestonesUrl;
      mobileLink.className = 'adn-mobile-link';
      mobileLink.textContent = 'Milestones';
      mobileLink.style.cssText = 'display:block; font-family:var(--font-heading); font-size:clamp(2.5rem,10vw,5rem); font-weight:300; line-height:1.15; color:rgba(255,255,255,0.7); text-decoration:none; opacity:0; transform:translateY(20px);';

      if (mobileStoryLink) {
        mobileStoryLink.insertAdjacentElement('afterend', mobileLink);
      } else {
        mobileNav.appendChild(mobileLink);
      }
    }
  }

  /* ==========================================================================
     9. Initialize All
     ========================================================================== */

  function init() {
    initScrollReveal();
    initNavbar();
    initHeroParallax();
    initCategoryFilter();
    initMobileMenu();
    initSmoothScroll();
    initLazyLoad();
    initMilestonesNavCacheGuard();
  }

  // Run on DOMContentLoaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init scroll reveal on Shopify section re-render
  document.addEventListener('shopify:section:load', function () {
    initScrollReveal();
    initCategoryFilter();
  });

})();
